module.exports = __webpack_public_path__ + "static/media/hangman00.5ce7117f.svg";